exports = module.exports = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"index.vue?vue&type=style&index=0&id=42f38cb6&lang=scss&scoped=true&","sourceRoot":""}]);

// exports
